import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen bg-white overflow-hidden flex flex-col items-center justify-center px-4 sm:px-6 pt-28 sm:pt-32 md:pt-36 lg:pt-40 pb-16 sm:pb-20"
    >
      <ScrollAnimation animation="fade-up" delay={100} duration={800}>
        <img
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/LOGOS_mesquita_BEGE-YnCMreWRgRNTZPJ4jIeO65RVDqcxAt.png"
          alt="Mesquita Psiquiatria e Psicoterapia"
          className="w-44 sm:w-56 md:w-72 lg:w-80 h-auto mx-auto mb-8 sm:mb-12"
        />
      </ScrollAnimation>

      <ScrollAnimation animation="fade-up" delay={300} duration={800}>
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-[#204613] text-center max-w-4xl mx-auto leading-tight mb-10 sm:mb-14">
          Cuidar da mente é integrar ciência, história e presença.
        </h1>
      </ScrollAnimation>

      <ScrollAnimation animation="fade-up" delay={500} duration={800}>
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <a
            href="https://wa.me/5548992100333"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#C2A44A] text-white rounded-full font-sans font-semibold text-base hover:bg-[#a8903f] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Agendar Consulta
            <ArrowRight className="w-5 h-5" />
          </a>
          <a
            href="https://wa.me/5548992100333"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#204613] text-white rounded-full font-sans font-semibold text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            <Phone className="w-5 h-5" />
            WhatsApp
          </a>
        </div>
      </ScrollAnimation>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-[#C2A44A]/50 flex items-start justify-center p-2">
          <div className="w-1.5 h-2.5 bg-[#C2A44A] rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
}
